"use client"

import { useEffect } from "react"
import { usePathname, useSearchParams } from "next/navigation"

const SETTINGS_RETURN_PATH_KEY = "settings-return-path"
const SETTINGS_RETURN_PATH_FALLBACK = "/clients"

function isSettingsFlowPath(pathname: string) {
  // Dashboard management lives under a book URL but returns to Settings.
  return pathname === "/settings" || pathname.startsWith("/settings/") || /^\/[^/]+\/dashboards(?:\/|$)/.test(pathname)
}

function isEntryPath(pathname: string) {
  return ["/", "/redirect", "/onboarding", "/welcome", "/dev-login"].includes(pathname.replace(/\/$/, "") || "/")
}

export function getSettingsReturnPath(fallback = SETTINGS_RETURN_PATH_FALLBACK) {
  const returnPath = sessionStorage.getItem(SETTINGS_RETURN_PATH_KEY)
  const returnPathname = returnPath?.split(/[?#]/, 1)[0]

  if (
    !returnPath?.startsWith("/") ||
    returnPath.startsWith("//") ||
    !returnPathname ||
    isSettingsFlowPath(returnPathname) ||
    isEntryPath(returnPathname)
  ) {
    return fallback
  }

  return returnPath
}

export function SettingsReturnPathTracker() {
  const pathname = usePathname()
  const searchParams = useSearchParams()

  useEffect(() => {
    if (isSettingsFlowPath(pathname) || isEntryPath(pathname)) return

    const search = searchParams.toString()
    const returnPath = search ? `${pathname}?${search}` : pathname
    sessionStorage.setItem(SETTINGS_RETURN_PATH_KEY, returnPath)
  }, [pathname, searchParams])

  return null
}
